/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketViewModel } from '../../models/support-ticket-view-model';

export interface GetBugSupportTickets$Params {
}

export function GetBugSupportTickets(http: HttpClient, rootUrl: string, params?: GetBugSupportTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SupportTicketViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetBugSupportTickets.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SupportTicketViewModel>>;
    })
  );
}

GetBugSupportTickets.PATH = '/api/ErrorLog/GetBugSupportTickets';
